import OrdersContainer from "../../container/admin/orders";

const OrdersView = () => {
    return <OrdersContainer />;
};

export default OrdersView;
